module.exports = __webpack_public_path__ + "static/logo-4494d96c9a3654506ad38eb124437885.png";